<template>
    <v-card v-if="obstacle!== undefined" class="obstacle-detail-card" :class="$vuetify.theme.dark ? 'transparent03--dark' : 'transparent03'" :height="minHeight">
        <v-card-text width="100%" height="100%" class="fill-height">
            <v-card-title class="text-no-wrap ma-2 mb-0 pb-0 mt-0" >
                <v-container max-width="40%" :class="$vuetify.theme.dark ? 'white--text' : 'black--text'" style="z-index: 9;">
                    <span class="pa-1" :style="`background-color: ${$vuetify.theme.dark ? 'rgba(0,0,0,0.63)' : 'rgba(255,255,255,0.63)'}; color: ${$vuetify.theme.dark ? '#fff' : '#000'}; border-radius: 5px;`">{{obstacle.obstacleType.name}}</span>
                    <v-progress-linear
                        background-color="error"
                        color="success"
                        height="10"
                        style="position: relative; top: -40px;"
                        class="caption pa-0 ma-0"
                        min-width="100"
                        :value="getHp()"
                    >
                        <strong> {{ obstacleHp }}/{{ obstacle.hp }}</strong>
                    </v-progress-linear>
                </v-container>
                <v-spacer/>
            </v-card-title>
            <v-img
                class="self-center obstacle-detail-icon"
                :src="getIcon"
                contain
                style="position: absolute; top: 0px;"
                height="100%"
            >
            </v-img>
        </v-card-text>


    </v-card>
</template>

<style scoped>
.obstacle-detail-card {
    /* Obrazek uvnitr (position:absolute) ma vlastni min-height nezavislou na
       skutecne vysce karty - na velmi nizkych viewportech by jinak "protekl"
       do sousedni trenerske karty pod ni. */
    overflow: hidden;
}
@media (min-width: 960px) {
    .obstacle-detail-card {
        height: 400px !important;
    }
}
.obstacle-detail-icon {
    /* v-img bez vyslovne vysky/aspect-ratio se nerenderuje (0px) - min-height
       je podlaha pro velmi male karty, height:100% (vyplni kartu) zustava. */
    min-height: 250px;
}
</style>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        components: {},
        props: {
            obstacle: {type: Object, default: undefined},
            obstacleHp: {type: Number, default: undefined},
            // Stejny vzor jako PokemonDetail.vue - minHeight posilaji
            // CombatantSlot.vue/BattleScreen.vue kvuli 50/50 mobil splitu.
            minHeight: {type: [Number, String], default: 400},
        },
        data() {
            return {
                show: false,
                loading: false,
            }
        },
        computed: {
            ...mapGetters({
                isLoading: 'journey/isLoading',
            }),
            getIcon(){
                let side = this.side;
                side = side ? side.toString()+'/': '';
                return require('@/assets/pic/obstacles/'+side+this.obstacle.obstacleType.name+'.png');
            },
        },
        watch: {
        },
        created() {
        },
        methods: {
            ...mapActions({
            }),
            getHp(){
                return parseInt(this.obstacleHp) / parseInt(this.obstacle.hp) * 100;
            },
        },
    }
</script>

